export enum HubTypes {
    MAIN = 'MAIN',
    SUB = 'SUB',
}
